import { render, staticRenderFns } from "./SpecimenPostureReportByCategory.vue?vue&type=template&id=16d62b99"
import script from "./SpecimenPostureReportByCategory.vue?vue&type=script&lang=js"
export * from "./SpecimenPostureReportByCategory.vue?vue&type=script&lang=js"
import style0 from "./SpecimenPostureReportByCategory.vue?vue&type=style&index=0&id=16d62b99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports